import striptags from 'striptags';
import { decode } from 'html-entities';
export const htmlToPlainText = (htmlString) => {
    if (!htmlString) {
        return '';
    }
    else {
        return striptags(decode(htmlString)
            .replace(/<br\s*\/?>|\n/gi, ' ')
            .replace(/([^\s>])(<\/[^>]+><[^>]+>)([^\s<])/g, '$1 $3')).trim();
    }
};
//# sourceMappingURL=htmlToPlainText.js.map